import React from "react";
import { useHistory } from "react-router-dom";
import Formsy from "formsy-react";

import { UrlProvider } from "../../../../../api/UrlProvider";
import FormBuilderWeb from "../../../../../lib/FormBuilder/FormBuilderWeb";
import AuthOrDivider from "../../../auth/AuthPageLayout/components/AuthOrDivider";
import AuthPageLayout from "../../../auth/AuthPageLayout";
import SocialLogin from "../../../auth/SocialLogin";
import { TextButton } from "../../../common/Typography";
import LoginRegisterPrompt from "./LoginRegisterPrompt";

function PasswordLoginForm({
  formBuilder,
  login: executeLogin,
  loginLoading,
  locale,
  translate,
  registerTo
}) {
  const history = useHistory();
  const forgotPasswordTo = UrlProvider.getUrl("fe.resetPassword", { locale });

  const { fields } = formBuilder;
  const loginFieldsBeforeForgot = fields.filter(
    field => field.name === "user" || field.name === "password"
  );
  const loginFieldsAfterForgot = fields.filter(
    field => field.name !== "user" && field.name !== "password"
  );

  return (
    <AuthPageLayout
      title={translate("auth_login-page_title")}
      subtitle={translate("auth_login-page_subtitle")}
    >
      <SocialLogin />
      <AuthOrDivider />
      <Formsy
        onValidSubmit={() => {
          executeLogin(formBuilder.fields);
        }}
      >
        <FormBuilderWeb {...formBuilder} fields={loginFieldsBeforeForgot} />
        <div className={"block text-sm text-black text-right w-full mb-4"}>
          <TextButton
            onClick={() => {
              history.push(forgotPasswordTo);
            }}
          >
            {translate("auth_login-page_forgot-password")}
          </TextButton>
        </div>
        {loginFieldsAfterForgot.length ? (
          <FormBuilderWeb {...formBuilder} fields={loginFieldsAfterForgot} />
        ) : null}
        <button
          type={"submit"}
          disabled={loginLoading}
          className={
            "hover.button focus.button disabled.button bg-yellow text-black text-lg py-4.5 border-none rounded-1xl px-7 font-semibold line-height-100 w-full mt-8 mb-6"
          }
        >
          {loginLoading ? (
            <i className="fal fa-spinner fa-spin text-black font-semibold mr-2" />
          ) : null}
          {translate("auth_login-page_submit")}
        </button>
        <LoginRegisterPrompt registerTo={registerTo} translate={translate} />
      </Formsy>
    </AuthPageLayout>
  );
}

export default PasswordLoginForm;
